import React, { useState } from 'react';
import { SearchIcon, FilterIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, StarIcon, ShieldIcon, FileTextIcon, ListIcon, ArrowRightIcon, EyeIcon } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
const DigitalAdvisorPortal = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  return <div className="max-w-6xl mx-auto" data-id="element-1522">
      <div className="mb-6" data-id="element-1523">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-1524">
          Digital Advisor Portal
        </h1>
        <p className="text-neutral-400" data-id="element-1525">
          Monitor and manage micro-sukuk applications throughout their lifecycle
        </p>
      </div>
      {/* Dashboard Overview */}
      <section className="mb-8" data-id="element-1526">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1527">
          <Card data-id="element-1528">
            <div className="flex items-center mb-2" data-id="element-1529">
              <div className="w-10 h-10 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1530">
                <ClockIcon className="w-5 h-5 text-primary" data-id="element-1531" />
              </div>
              <div data-id="element-1532">
                <h3 className="font-medium" data-id="element-1533">Pending Review</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-1534">8</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-1535">
              Awaiting initial assessment
            </div>
          </Card>
          <Card data-id="element-1536">
            <div className="flex items-center mb-2" data-id="element-1537">
              <div className="w-10 h-10 rounded-full bg-warning bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1538">
                <StarIcon className="w-5 h-5 text-warning" data-id="element-1539" />
              </div>
              <div data-id="element-1540">
                <h3 className="font-medium" data-id="element-1541">Rating Stage</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-1542">5</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-1543">
              With rating agency
            </div>
          </Card>
          <Card data-id="element-1544">
            <div className="flex items-center mb-2" data-id="element-1545">
              <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1546">
                <ShieldIcon className="w-5 h-5 text-secondary" data-id="element-1547" />
              </div>
              <div data-id="element-1548">
                <h3 className="font-medium" data-id="element-1549">Shariah Review</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-1550">3</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-1551">
              Awaiting Shariah compliance
            </div>
          </Card>
          <Card data-id="element-1552">
            <div className="flex items-center mb-2" data-id="element-1553">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1554">
                <ListIcon className="w-5 h-5 text-success" data-id="element-1555" />
              </div>
              <div data-id="element-1556">
                <h3 className="font-medium" data-id="element-1557">Ready to List</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-1558">2</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-1559">
              Contracts signed, ready for marketplace
            </div>
          </Card>
        </div>
      </section>
      {/* Application Management */}
      <section className="mb-8" data-id="element-1560">
        <Card data-id="element-1561">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6" data-id="element-1562">
            <h2 className="text-xl font-bold" data-id="element-1563">Micro-Sukuk Applications</h2>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2 mt-3 md:mt-0 w-full md:w-auto" data-id="element-1564">
              <div className="relative" data-id="element-1565">
                <input type="text" placeholder="Search applications..." className="pl-9 pr-4 py-2 border border-neutral-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary w-full md:w-auto" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1566" />
                <SearchIcon className="w-4 h-4 absolute left-3 top-3 text-neutral-400" data-id="element-1567" />
              </div>
              <Button variant="outline" icon={<FilterIcon className="w-4 h-4" data-id="element-1569" />} iconPosition="left" data-id="element-1568">
                Filter
              </Button>
            </div>
          </div>
          {/* Tabs */}
          <div className="mb-4 border-b border-neutral-200" data-id="element-1570">
            <div className="flex overflow-x-auto -mb-px" data-id="element-1571">
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'all' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('all')} data-id="element-1572">
                All Applications (18)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'pending' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('pending')} data-id="element-1573">
                Pending Review (8)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'rating' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('rating')} data-id="element-1574">
                Rating Stage (5)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'shariah' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('shariah')} data-id="element-1575">
                Shariah Review (3)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'ready' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('ready')} data-id="element-1576">
                Ready to List (2)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'listed' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('listed')} data-id="element-1577">
                Listed (12)
              </button>
            </div>
          </div>
          {/* Applications Table */}
          <div className="overflow-x-auto" data-id="element-1578">
            <table className="w-full" data-id="element-1579">
              <thead data-id="element-1580">
                <tr className="text-left border-b border-neutral-100" data-id="element-1581">
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-1582">ID</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-1583">
                    Business
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-1584">Purpose</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-1585">Amount</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-1586">
                    Submitted
                  </th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-1587">Stage</th>
                  <th className="pb-3 font-medium text-neutral-400" data-id="element-1588">Actions</th>
                </tr>
              </thead>
              <tbody data-id="element-1589">
                <tr className="border-b border-neutral-100" data-id="element-1590">
                  <td className="py-3" data-id="element-1591">#MS2023-105</td>
                  <td className="py-3" data-id="element-1592">Amani Cafe</td>
                  <td className="py-3" data-id="element-1593">Equipment Purchase</td>
                  <td className="py-3" data-id="element-1594">RM 25,000</td>
                  <td className="py-3" data-id="element-1595">2 days ago</td>
                  <td className="py-3" data-id="element-1596">
                    <span className="bg-primary bg-opacity-10 text-primary px-2 py-1 rounded-full text-xs font-medium" data-id="element-1597">
                      Pending Review
                    </span>
                  </td>
                  <td className="py-3" data-id="element-1598">
                    <Link to="/demo/advisor-assessment" data-id="element-1599">
                      <Button variant="primary" size="sm" data-id="element-1600">
                        Review
                      </Button>
                    </Link>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-1601">
                  <td className="py-3" data-id="element-1602">#MS2023-104</td>
                  <td className="py-3" data-id="element-1603">GreenTech Solutions</td>
                  <td className="py-3" data-id="element-1604">Inventory</td>
                  <td className="py-3" data-id="element-1605">RM 50,000</td>
                  <td className="py-3" data-id="element-1606">3 days ago</td>
                  <td className="py-3" data-id="element-1607">
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs font-medium" data-id="element-1608">
                      Rating Stage
                    </span>
                  </td>
                  <td className="py-3" data-id="element-1609">
                    <Button variant="outline" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-1611" />} iconPosition="left" data-id="element-1610">
                      View
                    </Button>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-1612">
                  <td className="py-3" data-id="element-1613">#MS2023-103</td>
                  <td className="py-3" data-id="element-1614">Modest Fashion House</td>
                  <td className="py-3" data-id="element-1615">Expansion</td>
                  <td className="py-3" data-id="element-1616">RM 80,000</td>
                  <td className="py-3" data-id="element-1617">5 days ago</td>
                  <td className="py-3" data-id="element-1618">
                    <span className="bg-secondary bg-opacity-10 text-secondary px-2 py-1 rounded-full text-xs font-medium" data-id="element-1619">
                      Shariah Review
                    </span>
                  </td>
                  <td className="py-3" data-id="element-1620">
                    <Button variant="outline" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-1622" />} iconPosition="left" data-id="element-1621">
                      View
                    </Button>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-1623">
                  <td className="py-3" data-id="element-1624">#MS2023-102</td>
                  <td className="py-3" data-id="element-1625">Halal Delights</td>
                  <td className="py-3" data-id="element-1626">Equipment</td>
                  <td className="py-3" data-id="element-1627">RM 35,000</td>
                  <td className="py-3" data-id="element-1628">1 week ago</td>
                  <td className="py-3" data-id="element-1629">
                    <span className="bg-success bg-opacity-10 text-success px-2 py-1 rounded-full text-xs font-medium" data-id="element-1630">
                      Ready to List
                    </span>
                  </td>
                  <td className="py-3" data-id="element-1631">
                    <Link to="/demo/micro-sukuk-listing" data-id="element-1632">
                      <Button variant="primary" size="sm" data-id="element-1633">
                        List Now
                      </Button>
                    </Link>
                  </td>
                </tr>
                <tr className="border-b border-neutral-100" data-id="element-1634">
                  <td className="py-3" data-id="element-1635">#MS2023-101</td>
                  <td className="py-3" data-id="element-1636">Tech Innovate</td>
                  <td className="py-3" data-id="element-1637">R&D</td>
                  <td className="py-3" data-id="element-1638">RM 60,000</td>
                  <td className="py-3" data-id="element-1639">2 weeks ago</td>
                  <td className="py-3" data-id="element-1640">
                    <span className="bg-accent bg-opacity-10 text-accent px-2 py-1 rounded-full text-xs font-medium" data-id="element-1641">
                      Listed
                    </span>
                  </td>
                  <td className="py-3" data-id="element-1642">
                    <Button variant="outline" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-1644" />} iconPosition="left" data-id="element-1643">
                      View
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-4 flex justify-between items-center" data-id="element-1645">
            <div className="text-sm text-neutral-400" data-id="element-1646">
              Showing 5 of 18 applications
            </div>
            <div className="flex space-x-2" data-id="element-1647">
              <Button variant="outline" size="sm" data-id="element-1648">
                Previous
              </Button>
              <Button variant="outline" size="sm" data-id="element-1649">
                Next
              </Button>
            </div>
          </div>
        </Card>
      </section>
      {/* Process Overview */}
      <section className="mb-8" data-id="element-1650">
        <h2 className="text-xl font-bold mb-4" data-id="element-1651">Micro-Sukuk Process Overview</h2>
        <Card data-id="element-1652">
          <div className="relative mb-8 pt-4" data-id="element-1653">
            {/* Pipeline Progress Bar */}
            <div className="absolute top-10 left-0 right-0 h-1 bg-neutral-200" data-id="element-1654">
              <div className="bg-primary h-1 w-full" data-id="element-1655"></div>
            </div>
            {/* Pipeline Stages */}
            <div className="flex justify-between relative" data-id="element-1656">
              {/* Stage 1: MSME Initiation */}
              <div className="flex flex-col items-center w-1/6" data-id="element-1657">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-1658">
                  <span className="text-white text-sm font-medium" data-id="element-1659">1</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-1660">
                  MSME Initiation
                </div>
                <div className="text-xs text-neutral-400 text-center mt-1" data-id="element-1661">
                  Application submission
                </div>
              </div>
              {/* Stage 2: Digital Advisor Review */}
              <div className="flex flex-col items-center w-1/6" data-id="element-1662">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-1663">
                  <span className="text-white text-sm font-medium" data-id="element-1664">2</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-1665">
                  Digital Advisor
                </div>
                <div className="text-xs text-neutral-400 text-center mt-1" data-id="element-1666">
                  Initial assessment
                </div>
              </div>
              {/* Stage 3: Rating Agency */}
              <div className="flex flex-col items-center w-1/6" data-id="element-1667">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-1668">
                  <span className="text-white text-sm font-medium" data-id="element-1669">3</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-1670">
                  Rating Agency
                </div>
                <div className="text-xs text-neutral-400 text-center mt-1" data-id="element-1671">
                  Risk assessment
                </div>
              </div>
              {/* Stage 4: Shariah Advisor */}
              <div className="flex flex-col items-center w-1/6" data-id="element-1672">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-1673">
                  <span className="text-white text-sm font-medium" data-id="element-1674">4</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-1675">
                  Shariah Advisor
                </div>
                <div className="text-xs text-neutral-400 text-center mt-1" data-id="element-1676">
                  Compliance review
                </div>
              </div>
              {/* Stage 5: Contract Signing */}
              <div className="flex flex-col items-center w-1/6" data-id="element-1677">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-1678">
                  <span className="text-white text-sm font-medium" data-id="element-1679">5</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-1680">
                  MSME Contract
                </div>
                <div className="text-xs text-neutral-400 text-center mt-1" data-id="element-1681">
                  E-signing
                </div>
              </div>
              {/* Stage 6: Marketplace Listing */}
              <div className="flex flex-col items-center w-1/6" data-id="element-1682">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-1683">
                  <span className="text-white text-sm font-medium" data-id="element-1684">6</span>
                </div>
                <div className="text-xs font-medium text-center" data-id="element-1685">
                  Marketplace
                </div>
                <div className="text-xs text-neutral-400 text-center mt-1" data-id="element-1686">
                  Investor subscription
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1687">
            <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-1688">
              <h4 className="font-medium mb-3" data-id="element-1689">Digital Advisor Actions</h4>
              <ul className="space-y-2 text-sm" data-id="element-1690">
                <li className="flex items-center" data-id="element-1691">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-1692" />
                  <span data-id="element-1693">Verify application completeness</span>
                </li>
                <li className="flex items-center" data-id="element-1694">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-1695" />
                  <span data-id="element-1696">Send applications for rating</span>
                </li>
                <li className="flex items-center" data-id="element-1697">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-1698" />
                  <span data-id="element-1699">Prepare and list approved sukuk</span>
                </li>
                <li className="flex items-center" data-id="element-1700">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-1701" />
                  <span data-id="element-1702">Monitor marketplace activity</span>
                </li>
              </ul>
            </div>
            <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 p-4 rounded-lg" data-id="element-1703">
              <h4 className="font-medium text-primary mb-3" data-id="element-1704">Pending Tasks</h4>
              <ul className="space-y-2 text-sm" data-id="element-1705">
                <li className="flex items-center" data-id="element-1706">
                  <ClockIcon className="w-4 h-4 text-primary mr-2 flex-shrink-0" data-id="element-1707" />
                  <span data-id="element-1708">8 applications awaiting initial review</span>
                </li>
                <li className="flex items-center" data-id="element-1709">
                  <ClockIcon className="w-4 h-4 text-primary mr-2 flex-shrink-0" data-id="element-1710" />
                  <span data-id="element-1711">2 applications ready for marketplace listing</span>
                </li>
                <li className="flex items-center" data-id="element-1712">
                  <ClockIcon className="w-4 h-4 text-primary mr-2 flex-shrink-0" data-id="element-1713" />
                  <span data-id="element-1714">3 vendor verifications pending</span>
                </li>
              </ul>
              <Button variant="primary" size="sm" className="mt-3" data-id="element-1715">
                View All Tasks
              </Button>
            </div>
            <div className="bg-warning bg-opacity-5 border border-warning border-opacity-20 p-4 rounded-lg" data-id="element-1716">
              <h4 className="font-medium text-warning mb-3" data-id="element-1717">
                Attention Required
              </h4>
              <ul className="space-y-2 text-sm" data-id="element-1718">
                <li className="flex items-center" data-id="element-1719">
                  <AlertCircleIcon className="w-4 h-4 text-warning mr-2 flex-shrink-0" data-id="element-1720" />
                  <span data-id="element-1721">2 applications with missing documentation</span>
                </li>
                <li className="flex items-center" data-id="element-1722">
                  <AlertCircleIcon className="w-4 h-4 text-warning mr-2 flex-shrink-0" data-id="element-1723" />
                  <span data-id="element-1724">1 rating pending for over 5 days</span>
                </li>
                <li className="flex items-center" data-id="element-1725">
                  <AlertCircleIcon className="w-4 h-4 text-warning mr-2 flex-shrink-0" data-id="element-1726" />
                  <span data-id="element-1727">1 marketplace listing expiring soon</span>
                </li>
              </ul>
              <Button variant="outline" size="sm" className="mt-3 border-warning text-warning hover:bg-warning hover:text-white" data-id="element-1728">
                Resolve Issues
              </Button>
            </div>
          </div>
        </Card>
      </section>
    </div>;
};
export default DigitalAdvisorPortal;